import { Component, input } from '@angular/core';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { IVacation } from 'src/app/entities/vacation/vacation.interface';
import { ICreneauInter } from 'src/app/entities/creneaux/creneau-inter.interface';
import { DeclarationPosition } from 'src/app/entities/vacation/declaration-position.model';
import { MainCouranteElement } from '../../main-courante-element.interface';

@Component({
  selector: 'in2-item-card-position',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.scss'],
  standalone: false,
})
export class MainCourantePositionComponent implements MainCouranteElement {
  readonly declaration = input.required<DeclarationPosition>();
  readonly vacation = input.required<IVacation>();
  readonly creneau = input.required<ICreneauInter>();

  public faMapMarkerAlt = faMapMarkerAlt;
}
